var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIservLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2105.07 755.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00447c;}.cls-2{fill:#7296c8;}.cls-3{fill:#faba00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.91,540.46a9.84,9.84,0,0,1-9.83-9.84V9.84A9.84,9.84,0,0,1,9.91,0H15.2a92.66,92.66,0,0,1,92.57,92.56V530.62a9.85,9.85,0,0,1-9.84,9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M414.48,540.33c-96.08.08-201.57-49.83-206.06-159.6a10,10,0,0,1,9.9-10.25l84.52-.07a9.73,9.73,0,0,1,9.53,8.95c3.75,38,45.58,63.41,104.09,63.36,59.22-.05,96-25,96-65.06-.47-47.91-54-59.51-116.11-72.93C312,286.49,216.46,265.82,216.36,149.31,216.28,62.89,298.1.1,410.89,0,524.2-.1,599.8,59.3,603.48,151.32a10,10,0,0,1-9.89,10.26l-84.53.07a9.75,9.75,0,0,1-9.55-8.91c-3.69-33.11-40.95-56.21-90.6-56.17-49.83.05-84.62,24.67-84.59,59.89,0,40.68,50.45,51.62,108.79,64.29C515.66,238.67,618.4,261,620.34,379.58c.46,42.34-12.94,77.59-39.84,104.79C544.91,520.4,485.94,540.27,414.48,540.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M941,540.46c-145.79,0-260-118.24-260-269.19C681,121.69,796.32,0,938,0c122.59,0,255.72,91.41,261,260.82a343.91,343.91,0,0,1-2.26,41.37,9.78,9.78,0,0,1-9.72,8.58H796.68a3.25,3.25,0,0,0-2.44,1.18,3.5,3.5,0,0,0-.84,2.79C804.48,387,862.6,435.59,938,435.59c46.19,0,86.18-16.86,115.7-48.74a9,9,0,0,1,6.71-3l103.61.92a9.75,9.75,0,0,1,8.34,4.9,10,10,0,0,1,.27,9.88C1126.14,486.48,1037.39,540.46,941,540.46Zm0-435.59C872,104.87,816,147.82,794.76,217a3.47,3.47,0,0,0,.54,3.07,3.25,3.25,0,0,0,2.62,1.38h284.16a3.17,3.17,0,0,0,2.6-1.39,3.35,3.35,0,0,0,.54-3.07C1064.33,149.91,1006.4,104.87,941,104.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1280.93,540.46A16.49,16.49,0,0,1,1264.45,524V298.19c0-215.5,134-295.33,259.48-298.19A10,10,0,0,1,1534,9.91V95a9.65,9.65,0,0,1-9.61,9.64c-94.31,0-151.23,72.36-152.27,193.58V524a16.5,16.5,0,0,1-16.48,16.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1800.66,540.46a10.13,10.13,0,0,1-9.41-6.34L1588.84,13.9A10.14,10.14,0,0,1,1598.27,0h91.47a10.11,10.11,0,0,1,9.42,6.41l144.16,382.42a3.57,3.57,0,0,0,6.62,0L1994,6.43A10.15,10.15,0,0,1,2003.46,0h91.47a10.12,10.12,0,0,1,9.38,13.94L1901.93,534.1a10.08,10.08,0,0,1-9.4,6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M808.86,755.85a53.85,53.85,0,1,1,0-107.69H2051.22a53.85,53.85,0,1,1,0,107.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M557.57,755.85c-30.93,0-54.27-23.15-54.27-53.85s23.34-53.84,54.27-53.84c29.95,0,53.42,23.65,53.42,53.84S587.52,755.85,557.57,755.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M305.93,755.85c-30.94,0-54.28-23.15-54.28-53.85s23.34-53.84,54.28-53.84c30,0,53.41,23.65,53.41,53.84S335.89,755.85,305.93,755.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.3,755.85C23.34,755.85,0,732.7,0,702s23.34-53.84,54.3-53.84c29.94,0,53.39,23.65,53.39,53.84S84.24,755.85,54.3,755.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIservLogo);
export default __webpack_public_path__ + "static/media/iserv-logo.c2453eefce7e7cef0f89dafe9dbfb969.svg";
export { ForwardRef as ReactComponent };